module.exports = __webpack_public_path__ + "static/media/cross.d14d44ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/cross.svg
// module id = 1313
// module chunks = 0